import { type RawApplicationContext } from 'browser/app';

import { type ApplicationContextCustom, type IApplicationContext } from 'shared/types/applicationContext';

export function createContext(rawApplicationContext: RawApplicationContext): IApplicationContext {
  return {
    ...rawApplicationContext,
    custom: rawApplicationContext.config.getStrict<ApplicationContextCustom>('applicationContext.custom'),
  };
}
